import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { IconComponent } from '@app/components/shared/icon/icon.component';
import { IconName } from '@app/utils/enums/icon-enum';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-delete-role-modal',
  standalone: true,
  imports: [TranslatePipe, CommonModule, MatButtonModule, IconComponent],
  templateUrl: './delete-role-modal.component.html',
  styleUrl: './delete-role-modal.component.scss',
})
export class DeleteRoleModalComponent {
  private readonly dialogRef = inject(MatDialogRef<DeleteRoleModalComponent>);
  public IconName = IconName;

  public close(result: boolean): void {
    this.dialogRef.close(result);
  }
}
